import React from "react";

import {
  RenewalSummary as RenewalSummaryType,
} from "./dashboardType"


interface Props {
  data: RenewalSummaryType;
}

const RenewalSummary: React.FC<Props> = ({
  data,
}) => {
  const items = [
    ["Renewals", data.Renewals],
    [
      "New Subscriptions",
      data.New_Subscriptions,
    ],
    ["Due Today", data.Due_Today],
    [
      "Due Next 3 Days",
      data.Due_Next_3_Days,
    ],
    [
      "Due Next 7 Days",
      data.Due_Next_7_Days,
    ],
    ["Expired", data.Expired],
  ];

  return (
    <section className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold">
        Renewals
      </h2>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
        {items.map(
          ([label, value]) => (
            <div
              key={String(label)}
              className="rounded-lg bg-gray-50 p-4"
            >
              <p className="text-sm text-gray-500">
                {label}
              </p>

              <p className="mt-1 text-xl font-bold">
                {value}
              </p>
            </div>
          )
        )}
      </div>
    </section>
  );
};

export default RenewalSummary;